import {pathname} from "../../../common/others/Configuration";
import $ from "jquery";
import SharedDispatcher from "../../../common/others/SharedDispatcher";

const baseUrl = pathname + '/popins/';

export default (opts, data = null) => {
  if (!opts.popinPageName && !opts.url) {
    throw new TypeError('Popin needs url or pageName');
  }

  SharedDispatcher.trigger('overlay:show');

  const url = opts.url || (baseUrl + opts.popinPageName);

  return $.ajax({
    url,
    type: 'GET',
    dataType: 'html',
    data
  }).always(function () {
    SharedDispatcher.trigger('overlay:hide')
  });
}
